import './Contacto.css'

export default function Contacto() {
    return (
        <div className="container">
			<div className="theme-band"></div>
			<div className="article contacto">
				<h1>Contacto</h1>
				<ul>
					<li>María Ángeles Les López</li>
					<li>e-mail: <a href="mailto: " className="mail">info@correofake.com</a></li>
					<li>teléfono: 987 65 43 21</li>
				</ul>
				<br/><br/><br/>	
			</div>	
		</div>
    )
}
